<button class="add-edit-button" [disabled]="disabled">
  <mat-icon
    class="btn"
    [class.disabled]="disabled"
    (click)="onClick.emit()"
  >cancel</mat-icon>
</button>
